import React from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  eyebrow?: string;
  className?: string;
};

export default function FeatureCard({ title, children, icon, eyebrow, className = '' }: Props) {
  return (
    <article className={`relative overflow-hidden rounded-[1.5rem] border border-[#dbe8f5] bg-white p-6 shadow-[0_24px_50px_-36px_rgba(13,27,42,0.75)] transition-all duration-300 hover:-translate-y-1 hover:border-[#2b6cb0]/45 hover:shadow-[0_36px_72px_-42px_rgba(13,27,42,0.55)] ${className}`}>
      <div className="absolute right-4 top-4 rounded-full bg-[#fff1e8] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[var(--brand-accent-strong)]">Service</div>
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#e9f2fb] text-2xl text-[#2b6cb0]">
        {icon}
      </div>
      {eyebrow && <p className="mt-5 text-xs font-semibold uppercase tracking-[0.24em] text-[#2b6cb0]">{eyebrow}</p>}
      <h3 className="mt-3 text-[1.45rem] leading-tight text-[#102a43]">{title}</h3>
      <p className="mt-3 text-sm leading-7 text-[#4c5f75]">{children}</p>
      <div className="mt-6 h-px w-full bg-gradient-to-r from-[#2b6cb0]/50 to-transparent" />
    </article>
  );
}
